import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  OnInit,
} from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';

import {
  ButtonModule,
  DIALOG_DATA,
  DialogRef,
  IconModule,
  SimpleInputModule,
  UaParserService,
} from '@hglobal/fin-ui';
import { FormBuilder } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';

import { LogoComponent } from '@iw/common';
import { AuthStore, Enable2FAData } from '@iw/core/auth-store';

@Component({
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    QRCodeComponent,
    ButtonModule,
    IconModule,
    SimpleInputModule,
    LogoComponent,
    NgTemplateOutlet,
  ],
  selector: 'iw-tfa-enable',
  templateUrl: './tfa-enable.component.html',
  styleUrls: ['./tfa-enable.component.scss', '../signin-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TfaEnableComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #store = inject(AuthStore);
  readonly #dialogRef = inject(DialogRef);
  readonly #uaParser = inject(UaParserService);
  readonly data = inject<Enable2FAData>(DIALOG_DATA, {
    optional: true,
  });

  manualSetupUri = this.data?.manualSetupUri;
  isLoading = false;
  isIOS = this.#uaParser.isIOS;

  form = this.#fb.group({
    code: ['', Validators.required],
  });
  errorDictionary: Record<string, string> = {
    apiValidation: 'errors.invalid_two_factor_code',
  };

  readonly verifyCodeSuccessEffect = effect(() => {
    const verified = this.#store.isVerifyCodeSuccess();
    if (verified) {
      this.isLoading = false;
      this.#dialogRef.close();
    }
  });

  readonly verifyCodeFailedEffect = effect(() => {
    const error = this.#store.verifyCodeError();
    if (error) {
      this.isLoading = false;
      error?.code === 'invalid_two_factor_code' &&
        this.form.controls.code.setErrors({ apiValidation: true });
    }
  });

  ngOnInit(): void {
    if (!this.data) {
      this.#store.enable2fa();
    }
  }

  verify(): void {
    this.isLoading = true;
    this.#store.verifyCode({ ...this.form.value });
  }
}
